import React from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import {
    LANDMARKS_PHONE_DISPLAY,
    LANDMARKS_PHONE_TEL,
    LANDMARKS_WHATSAPP_URL,
    openTelDialer,
} from "../constants/contactLinks";

/**
 * Fixed bottom-right Call (top) + WhatsApp (below), visible on every page.
 */
export default function FloatingContactActions() {
    const btnRing =
        "shadow-[0_8px_24px_rgba(0,0,0,0.18)] ring-[3px] ring-white dark:ring-slate-900 transition-transform duration-200 hover:scale-105 hover:shadow-[0_12px_28px_rgba(0,0,0,0.22)] active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950";

    return (
        <aside
            className="fixed z-[100] flex flex-col items-center gap-3 pointer-events-none [&_a]:pointer-events-auto bottom-[max(1.25rem,env(safe-area-inset-bottom,0px))] right-[max(1.25rem,env(safe-area-inset-right,0px))] sm:bottom-7 sm:right-7"
            aria-label="Quick contact shortcuts"
        >
            {/* 1 — Call */}
            <a
                href={LANDMARKS_PHONE_TEL}
                onClick={openTelDialer}
                className={`flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-full bg-[#3B2B9A] text-white ${btnRing} focus-visible:ring-[#3B2B9A]/45`}
                title={`Call ${LANDMARKS_PHONE_DISPLAY}`}
                aria-label={`Call Landmarks Realty at ${LANDMARKS_PHONE_DISPLAY}`}
            >
                <FaPhoneAlt className="text-xl" aria-hidden />
            </a>

            {/* 2 — WhatsApp */}
            <a
                href={LANDMARKS_WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white ${btnRing} focus-visible:ring-[#25D366]/45`}
                title={`WhatsApp ${LANDMARKS_PHONE_DISPLAY}`}
                aria-label={`WhatsApp Landmarks Realty ${LANDMARKS_PHONE_DISPLAY}`}
            >
                <FaWhatsapp className="text-[1.65rem]" aria-hidden />
            </a>
        </aside>
    );
}
